<template>
  <el-dialog
    :title="$t('config.profile.title.companyForm')"
    :visible.sync="dialogFormVisible"
    width="70%"
    :close-on-click-modal="false"
    @close="agentItem = { ...defaultAgentItem }"
  >
    <div v-if="dialogFormVisible">
      <validation-observer ref="formValidator">
        <div class="das-form-container datnt">
          <!-- <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3"></div>
            <div class="das-form-col col-3" />
            <div class="das-form-col col-3"></div>
          </div>
        </div> -->

          <div class="das-form-group" style="margin-bottom: 0">
            <div class="das-form-row" style="margin-bottom: 0">
              <div class="das-form-col col-8">
                <div class="das-form-group-title">
                  {{ $t('config.profile.title.companyFormSub1') }}
                </div>
                <div class="das-form-container">
                  <div class="das-form-group" style="margin-bottom: 0">
                    <div class="das-form-row">
                      <div class="das-form-col col-6">
                        <div class="das-form-input">
                          <div class="label required">
                            {{ $t('config.profile.field.profileCode') }}
                          </div>
                          <validation-provider rules="required" name="Mã hồ sơ">
                            <div class="child-w-80">
                              <input
                                v-model="agentItem.profile_code"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </validation-provider>
                        </div>
                      </div>
                      <div class="das-form-col col-6">
                        <div class="das-form-input">
                          <div class="label">
                            {{ $t('config.profile.field.email') }}
                          </div>
                          <validation-provider rules="email" name="Email">
                            <div class="child-w-80">
                              <input
                                v-model="agentItem.email"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </validation-provider>
                        </div>
                      </div>
                    </div>

                    <div class="das-form-row">
                      <div class="das-form-col col-6">
                        <div class="das-form-input">
                          <div class="label required">
                            {{ $t('config.profile.field.name') }}
                          </div>
                          <validation-provider
                            rules="required"
                            name="Tên công ty, đại lý du lịch"
                          >
                            <div class="child-w-80">
                              <input
                                v-model="agentItem.name"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </validation-provider>
                        </div>
                      </div>

                      <div class="das-form-col col-6">
                        <div class="das-form-input">
                          <div class="label required">
                            {{ $t('config.profile.field.phone') }}
                          </div>
                          <validation-provider
                            :rules="`required|phoneNumber:${vueTelIso2.phone_1},${vueTelDialCode.phone_1}`"
                            name="Số điện thoại"
                          >
                            <div class="child-w-80">
                              <tel-input
                                v-model="agentItem.phone_1"
                                @country-changed="countryChangeP1"
                              />
                              <!-- <vue-tel-input
                              v-model="agentItem.phone_1"
                              v-numeric-only
                              default-country="VN"
                              :input-options="vueTelOptions"
                              @country-changed="countryChangeP1"
                            /> -->
                            </div></validation-provider
                          >
                        </div>
                      </div>
                    </div>

                    <div class="das-form-row">
                      <div class="das-form-col col-6">
                        <div class="das-form-input">
                          <div class="label">
                            {{ $t('config.profile.field.invoiceAgentName') }}
                          </div>
                          <validation-provider
                            rules=""
                            name="Tên công ty trên hóa đơn"
                          >
                            <div class="child-w-80">
                              <input
                                v-model="agentItem.invoice_agent_name"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </validation-provider>
                        </div>
                      </div>

                      <div class="das-form-col col-6">
                        <div class="das-form-input">
                          <div class="label">
                            {{ $t('config.profile.field.address') }}
                          </div>
                          <validation-provider rules="" name="Địa chỉ ">
                            <div class="child-w-80">
                              <input
                                v-model="agentItem.address_1"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </validation-provider>
                        </div>
                        <!-- <div class="das-form-input">
                        <div class="label">
                          {{ $t('config.profile.field.phone2') }}
                        </div>
                        <validation-provider
                          :rules="`phoneNumber:${vueTelIso2.phone_2},${vueTelDialCode.phone_2}`"
                          name="Số điện thoại 2"
                        >
                          <div class="child-w-80">
                            <tel-input
                              v-model="agentItem.phone_2"
                              @country-changed="countryChangeP2"
                            />
                          </div>
                        </validation-provider>
                      </div> -->
                      </div>
                    </div>

                    <div class="das-form-row">
                      <div class="das-form-col col-6">
                        <div class="das-form-input">
                          <div class="label required">
                            {{ $t('config.profile.field.profileType') }}
                          </div>
                          <validation-provider
                            rules="required|integer"
                            name="Loại hồ sơ"
                          >
                            <div class="child-w-80">
                              <select-with-search-table
                                style="width: 100%"
                                index-field="code"
                                :search-fields="['name', 'desc']"
                                :selected-index-field-value="
                                  agentItem.profile_type
                                "
                                :value="agentItem.profile_type"
                                :rows="profileTpRows"
                                :columns="profileTpCols"
                                :dropdown-width="500"
                                :is-remove-btn="true"
                                @selectionChanged="onSelectProfileTp"
                              >
                                <template
                                  v-slot:value="{ selectedValue: selectedData }"
                                >
                                  <div>
                                    <span>
                                      {{
                                        `${selectedData?.code || ''} - ${
                                          selectedData?.name || ''
                                        }`
                                      }}
                                    </span>
                                  </div>
                                </template>
                              </select-with-search-table>
                            </div>
                          </validation-provider>
                        </div>
                      </div>

                      <div class="das-form-col col-6">
                        <div class="das-form-input">
                          <div class="label">
                            {{ $t('config.profile.field.city') }}
                          </div>
                          <validation-provider rules="" name="Thành phố">
                            <div class="child-w-80">
                              <input
                                v-if="cityInputType === 'input'"
                                v-model="agentItem.city_name"
                                type="text"
                                placeholder=""
                              />
                              <el-select
                                v-if="cityInputType === 'select'"
                                v-model="agentItem.city_name"
                                placeholder=""
                                filterable
                                @change="onSelectCity"
                              >
                                <el-option
                                  v-for="(item, index) in provinces"
                                  :key="index"
                                  :label="item.name"
                                  :value="item.name"
                                >
                                </el-option>
                              </el-select>
                            </div>
                          </validation-provider>
                        </div>
                      </div>
                    </div>

                    <div class="das-form-row">
                      <div class="das-form-col col-6">
                        <div class="das-form-input">
                          <div class="label">
                            {{ $t('config.profile.field.bankNumber') }}
                          </div>
                          <validation-provider rules="" name="Số tài khoản">
                            <div class="child-w-80">
                              <input
                                v-model="agentItem.bank_number"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </validation-provider>
                        </div>
                      </div>
                      <!-- <div class="das-form-col col-6">
                      <div class="das-form-input">
                        <div class="label">
                          {{ $t('config.profile.field.zipCode') }}
                        </div>
                        <validation-provider rules="" name="Mã bưu điện">
                          <div class="child-w-80">
                            <input
                              v-model="agentItem.zip_code"
                              type="text"
                              placeholder=""
                            />
                          </div>
                        </validation-provider>
                      </div>
                    </div> -->

                      <div class="das-form-col col-6">
                        <div class="das-form-input">
                          <div class="label">
                            {{ $t('config.profile.field.nation') }}
                          </div>
                          <validation-provider rules="integer" name="Quốc gia">
                            <div class="child-w-80">
                              <select-with-search-table
                                style="width: 100%"
                                :search-fields="['code', 'desc']"
                                index-field="id"
                                :selected-index-field-value="
                                  agentItem.nation_id
                                "
                                :rows="nationRows"
                                :columns="nationCols"
                                :value="agentItem.nation_id"
                                :dropdown-width="400"
                                :is-remove-btn="true"
                                @selectionChanged="onSelectNation"
                              >
                                <template
                                  v-slot:value="{ selectedValue: selectedData }"
                                >
                                  <div>
                                    <span>
                                      {{
                                        `${selectedData?.code || ''} - ${
                                          selectedData?.desc || ''
                                        }`
                                      }}
                                    </span>
                                  </div>
                                </template>
                              </select-with-search-table>
                            </div>
                          </validation-provider>
                        </div>
                      </div>
                      <!-- <div class="das-form-col col-6">
                      <div class="das-form-input">
                        <div class="label">
                          {{ $t('config.profile.field.businessCode') }}
                        </div>
                        <validation-provider rules="" name="Mã doanh nghiệp">
                          <div class="child-w-80">
                            <input
                              v-model="agentItem.business_code"
                              type="text"
                              placeholder=""
                            />
                          </div>
                        </validation-provider>
                      </div>
                    </div> -->

                      <!-- <div class="das-form-col col-6">
                      <div class="das-form-input">
                        <div class="label">
                          {{ $t('config.profile.field.address2') }}
                        </div>
                        <validation-provider rules="" name="Địa chỉ 2">
                          <div class="child-w-80">
                            <input
                              v-model="agentItem.address_2"
                              type="text"
                              placeholder=""
                            />
                          </div>
                        </validation-provider>
                      </div>
                    </div> -->
                    </div>

                    <div class="das-form-row">
                      <div class="das-form-col col-6">
                        <div class="das-form-input">
                          <div class="label">
                            {{ $t('config.profile.field.taxCode') }}
                          </div>
                          <validation-provider rules="" name="Mã số thuế">
                            <div class="child-w-80">
                              <input
                                v-model="agentItem.tax_code"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </validation-provider>
                        </div>
                      </div>

                      <div class="das-form-col col-6">
                        <div class="das-form-input">
                          <div class="label">
                            {{ $t('config.profile.field.businessManName') }}
                          </div>
                          <validation-provider
                            rules=""
                            name="Nhân viên kinh doanh theo chuỗi"
                          >
                            <div class="child-w-80">
                              <select-with-search-table
                                style="width: 100%"
                                :search-fields="['id', 'full_name']"
                                index-field="id"
                                :selected-index-field-value="
                                  agentItem.business_person_id
                                "
                                :value="agentItem.business_person_id"
                                :rows="businessManRows"
                                :columns="businessManCols"
                                :dropdown-width="500"
                                :is-remove-btn="true"
                                @selectionChanged="onSelectBusinessMan"
                              >
                                <template
                                  v-slot:value="{ selectedValue: selectedData }"
                                >
                                  <div>
                                    <span>
                                      {{ selectedData?.full_name }}
                                    </span>
                                  </div>
                                </template>
                              </select-with-search-table>
                            </div>
                          </validation-provider>
                        </div>
                      </div>
                    </div>

                    <div class="das-form-row">
                      <div class="das-form-col col-6">
                        <div class="das-form-input">
                          <div class="label">
                            {{ $t('config.profile.field.bankName') }}
                          </div>
                          <validation-provider rules="" name="Tên ngân hàng">
                            <div class="child-w-80">
                              <input
                                v-model="agentItem.bank_name"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </validation-provider>
                        </div>
                      </div>

                      <div class="das-form-col col-6">
                        <div class="das-form-input">
                          <div class="label">
                            {{ $t('config.profile.field.note') }}
                          </div>
                          <validation-provider rules="" name="Ghi chú">
                            <div class="child-w-80">
                              <input
                                v-model="agentItem.note"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </validation-provider>
                        </div>
                      </div>

                      <!-- <div class="das-form-col col-6">
                      <div class="das-form-input">
                        <div class="label">
                          {{ $t('config.profile.field.state') }}
                        </div>
                        <validation-provider rules="" name="Tiểu bang">
                          <div class="child-w-80">
                            <input
                              v-model="agentItem.state_name"
                              type="text"
                              placeholder=""
                            />
                          </div>
                        </validation-provider>
                      </div>
                    </div> -->
                    </div>

                    <div class="das-form-row">
                      <div class="das-form-col col-6">
                        <div class="das-form-input">
                          <div class="label">
                            {{ 'Ngày ký hợp đồng' }}
                          </div>
                          <validation-provider rules="" name="Ngày ký hợp đồng">
                            <div class="child-w-80">
                              <calendar-select
                                ref="FIELD_NAME.signed_date"
                                v-model="agentItem.signed_date"
                                mode="date"
                              />
                            </div>
                          </validation-provider>
                        </div>
                      </div>

                      <div class="das-form-col col-6">
                        <div class="das-form-input">
                          <div class="label">
                            {{ 'Ngày hết hạn' }}
                          </div>
                          <validation-provider rules="" name="Ngày hết hạn">
                            <div class="child-w-80">
                              <calendar-select
                                ref="FIELD_NAME.expired_date"
                                v-model="agentItem.expired_date"
                                mode="date"
                              />
                            </div>
                          </validation-provider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="das-form-col col-4">
                <div class="das-form-group-title">
                  {{ $t('config.profile.title.companyFormSub6') }}
                </div>
                <div class="das-form-container">
                  <div class="das-form-group" style="margin-bottom: 0">
                    <div class="das-form-row">
                      <div class="das-form-col col-12">
                        <div class="das-form-input">
                          <div class="label">
                            {{ $t('config.profile.field.repName') }}
                          </div>
                          <validation-provider rules="" name="Người đại diện">
                            <div class="child-w-80">
                              <input
                                v-model="agentItem.representative_name"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </validation-provider>
                        </div>
                      </div>
                    </div>

                    <div class="das-form-row">
                      <div class="das-form-col col-12">
                        <div class="das-form-input">
                          <div class="label">
                            {{ $t('config.profile.field.email') }}
                          </div>
                          <validation-provider
                            rules="email"
                            name="Email của người đại diện"
                          >
                            <div class="child-w-80">
                              <input
                                v-model="agentItem.representative_email"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </validation-provider>
                        </div>
                      </div>
                    </div>

                    <div class="das-form-row">
                      <div class="das-form-col col-12">
                        <div class="das-form-input">
                          <div class="label">
                            {{ $t('config.profile.field.phone') }}
                          </div>
                          <validation-provider
                            :rules="`phoneNumber:${vueTelIso2.representative_number_phone_1},${vueTelDialCode.representative_number_phone_1}`"
                            name="Số điện thoại 1 của người đại diện"
                          >
                            <div class="child-w-80">
                              <tel-input
                                v-model="
                                  agentItem.representative_number_phone_1
                                "
                                @country-changed="countryChange1"
                              />
                            </div>
                          </validation-provider>
                        </div>
                      </div>
                    </div>

                    <!-- <div class="das-form-row">
                      <div class="das-form-col col-12">
                        <div class="das-form-input">
                        <div class="label">
                          {{ $t('config.profile.field.phone2') }}
                        </div>
                        <validation-provider
                          :rules="`phoneNumber:${vueTelIso2.representative_number_phone_2},${vueTelDialCode.representative_number_phone_2}`"
                          name="Số điện thoại 2 của người đại diện"
                        >
                          <div class="child-w-80">
                            <tel-input
                              v-model="agentItem.representative_number_phone_2"
                              @country-changed="countryChange2"
                            />
                          </div>
                        </validation-provider>
                      </div>
                      </div>
                    </div> -->

                    <div class="das-form-row">
                      <div class="das-form-col col-12">
                        <div class="das-form-input">
                          <div class="label">
                            {{ $t('config.profile.field.birth') }}
                          </div>
                          <validation-provider rules="" name="Ngày sinh">
                            <div class="child-w-80">
                              <calendar-select
                                ref="FIELD_NAME.representative_birthday"
                                v-model="agentItem.representative_birthday"
                                mode="date"
                              />
                            </div>
                          </validation-provider>
                        </div>
                      </div>
                    </div>

                    <div class="das-form-row">
                      <div class="das-form-col col-12">
                        <div class="das-form-input">
                          <div class="label">
                            {{ $t('config.profile.field.idCard') }}
                          </div>
                          <validation-provider rules="" name="Thẻ căn cước">
                            <div class="child-w-80">
                              <input
                                v-model="agentItem.representative_id_card"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </validation-provider>
                        </div>
                      </div>
                    </div>

                    <div class="das-form-row">
                      <div class="das-form-col col-12">
                        <div class="das-form-input">
                          <div class="label">
                            {{ $t('config.profile.field.idCardIssuedDate') }}
                          </div>
                          <validation-provider rules="" name="Ngày cấp">
                            <div class="child-w-80">
                              <calendar-select
                                ref="FIELD_NAME.representative_card_date"
                                v-model="agentItem.representative_card_date"
                                mode="date"
                              />
                            </div>
                          </validation-provider>
                        </div>
                      </div>
                    </div>

                    <div class="das-form-row">
                      <div class="das-form-col col-12">
                        <div class="das-form-input">
                          <div class="label">
                            {{ $t('config.profile.field.idCardIssuedPlace') }}
                          </div>
                          <validation-provider rules="" name="Nơi cấp">
                            <div class="child-w-80">
                              <input
                                v-model="agentItem.representative_card_place"
                                type="text"
                                placeholder=""
                              />
                            </div>
                          </validation-provider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="das-form-group" style="margin: -5px 0 0">
            <div class="das-form-row" style="margin: 0">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label">{{ $t('config.profile.field.note') }}</div>
                  <validation-provider rules="" name="Ghi chú">
                    <div class="child-w-80">
                      <textarea
                        v-model="agentItem.note"
                        rows="2"
                        style="resize: none"
                        type="text"
                        placeholder=""
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
          </div> -->

          <div class="das-form-group">
            <div class="das-form-group-title">
              {{ $t('config.profile.title.companyFormSub2') }}
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label">
                    {{ $t('config.profile.field.marketSeg') }}
                  </div>
                  <validation-provider
                    rules="integer"
                    name="Phân khúc thị trường"
                  >
                    <div class="child-w-80">
                      <select-with-search-table
                        style="width: 100%"
                        :search-fields="['desc', 'code']"
                        index-field="id"
                        :selected-index-field-value="agentItem.market_seg_id"
                        :value="agentItem.market_seg_id"
                        :rows="marketSegRows"
                        :columns="marketSegCols"
                        :dropdown-width="400"
                        :is-remove-btn="true"
                        @selectionChanged="onSelectMarketSeg"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          <div>
                            <span>
                              {{
                                `${selectedData?.id || ''} - ${
                                  selectedData?.code || ''
                                }`
                              }}
                            </span>
                          </div>
                        </template>
                      </select-with-search-table>
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('config.profile.field.source') }}
                  </div>
                  <validation-provider rules="required|integer" name="Nguồn">
                    <div class="child-w-80">
                      <select-with-search-table
                        style="width: 100%"
                        :search-fields="['desc', 'code']"
                        index-field="id"
                        :selected-index-field-value="agentItem.source_id"
                        :value="agentItem.source_id"
                        :rows="sourceRows"
                        :columns="sourceCols"
                        :dropdown-width="400"
                        :is-remove-btn="true"
                        @selectionChanged="onSelectSource"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          <div>
                            <span>
                              {{
                                `${selectedData?.id || ''} - ${
                                  selectedData?.code || ''
                                }`
                              }}
                            </span>
                          </div>
                        </template>
                      </select-with-search-table>
                    </div>
                  </validation-provider>
                </div>
              </div>

              <!-- <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">Phân khúc kinh doanh</div>
                <validation-provider
                  rules="required|integer"
                  name="Phân khúc kinh doanh"
                >
                  <div class="child-w-80">
                    <select
                      id=""
                      v-model="agentItem.business_seg_id"
                      name=""
                      placeholder="Chọn"
                    >
                      <option
                        v-for="item in [1, 2, 3]"
                        :key="item"
                        :value="item"
                      >
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </validation-provider>
              </div>
            </div> -->
            </div>
          </div>

          <div v-if="checkAuthorAddDebtAccount" class="das-form-group">
            <div class="das-form-group-title flex align-center gap-4">
              <div>{{ $t('config.profile.title.companyFormSub5') }}</div>
              <div>
                <el-switch
                  v-model="agentItem.debit_account_active"
                  active-color="#357456"
                  inactive-color="#CAC9C9"
                />
                <span class="ml-10">{{ 'Hoạt động' }}</span>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label">
                    {{ 'Số ngày được nợ' }}
                  </div>
                  <validation-provider rules="integer">
                    <div class="child-w-80">
                      <input
                        v-model="agentItem.day_owed_num"
                        :disabled="agentItem.debit_account_active == false"
                        type="number"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label">
                    {{ 'Số tiền nợ tối đa (VND)' }}
                  </div>
                  <validation-provider rules="integer" name="Nguồn">
                    <VxCurrencyInput
                      v-model="agentItem.max_debt_amount"
                      :disabled-flag="agentItem.debit_account_active == false"
                      style="flex: 2"
                    />
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-4">
                <!-- <div class="das-form-input"> -->
                <div class="label">
                  {{ 'Đẩy nợ Ticket' }}
                </div>
                <validation-provider rules="" name="">
                  <el-switch
                    v-model="agentItem.is_apply_ticket"
                    active-color="#357456"
                    inactive-color="#CAC9C9"
                  />
                  <span class="ml-10">{{ 'Được phép' }}</span>
                </validation-provider>
                <!-- <div
                    class="checkbox-wrap"
                    style="display: flex; flex-direction: column"
                  >
                    <input
                      id="isRoomBooking"
                      v-model="agentItem.is_apply_ticket"
                      type="checkbox"
                    />
                    <label for="isRoomBooking">Được phép đẩy nợ Ticket</label>
                  </div> -->
                <!-- </div> -->
              </div>
            </div>
          </div>

          <div class="das-form-group">
            <div class="das-form-group-title">
              {{ $t('config.profile.title.companyFormSub3') }}
            </div>
            <div class="das-form-row">
              <div
                class="grid-scroll mt-10"
                style="height: calc(40px + 5 * 34px)"
              >
                <GridVx
                  ref="contactGrid"
                  class="agGrid"
                  :columns="contactCols"
                  :rows="agentItem.contact_list"
                  :context="context"
                  :auto-select-first-row="false"
                  :auto-size-cell="true"
                />
              </div>
            </div>
          </div>

          <!-- <div class="das-form-group">
            <div class="das-form-group-title">
              {{ $t('config.profile.title.companyFormSub4') }}
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="checkbox-wrap">
                    <input
                      id="other_infor"
                      v-model="agentItem.other_infor"
                      type="checkbox"
                    />
                    <label for="other_infor">{{
                      $t('config.profile.dialog.companyCbLabel')
                    }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

          <!-- <div class="das-form-group">
            <div class="das-form-group-title flex align-center gap-4">
              <div>{{ $t('config.profile.title.companyFormSub5') }}</div>
              <button
                class="btn primary small"
                @click="debitAccountDialogVisible = true"
              >
                {{ $t('config.profile.common.assignAccount') }}
              </button>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="grid-scroll mt-10" style="height: 200px">
                  <GridVx
                    ref="accountReceivableGrid"
                    class="agGrid"
                    :columns="accountReceivableCols"
                    :rows="agentItem.agent_debit_list"
                    :context="context"
                    :auto-select-first-row="false"
                    :auto-size-cell="true"
                  />
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </validation-observer>

      <el-dialog
        :title="$t('config.profile.title.assignAccountDialog')"
        :visible.sync="debitAccountDialogVisible"
        width="50%"
        append-to-body
      >
        <div>
          <MultiGridsTransfer
            :title1="$t('config.profile.dialog.unattachListTitle')"
            :title2="$t('config.profile.dialog.attachListTitle')"
            :columns1="attachedDebtAccountCols"
            :rows1="unAttachedDebtAccountRows"
            :columns2="attachedDebtAccountCols"
            :rows2="attachedDebtAccountRows"
            @transferData="updateAttachedDebtAccount"
          />
        </div>

        <span slot="footer" class="dialog-footer">
          <div class="button-containers">
            <button
              class="btn primary small outline"
              @click="debitAccountDialogVisible = false"
            >
              {{ $t('config.profile.common.close') }}
            </button>
          </div>
        </span>
      </el-dialog>
    </div>
    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button class="btn primary small outline" @click="onCancel">
          {{ $t('config.profile.common.cancel') }}
        </button>
        <button v-if="isEdit" class="btn primary small" @click="updateAgent">
          {{ $t('config.profile.common.update') }}
        </button>
        <button v-else class="btn primary small" @click="addAgent">
          {{ $t('config.profile.common.create') }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
/* eslint-disable */
import VxCurrencyInput from '@/components/ui/VxCurrencyInput'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import {
  CellRenderDeleteIcon,
  CellRenderTextInput,
  CellHeaderAddIcon
} from '@/utils/cellRenders.js'

// import CellRenderAddHeader from '../../components/CellRenderAddHeader.vue'
import MultiGridsTransfer from '@/components/grid/MultiGridsTransfer.vue'

import {
  addAgentApi,
  getAgentByIdApi,
  updateAgentApi
} from '@/api/configuration/profile/agent.js'
import { getListDebitAccount } from '@/api/configuration/accounting/debitAccount'
import {
  getAllBusinessMan,
  getAllMarketSeg,
  getAllNation,
  getAllSource
} from '../../commonApiCall'
import { checkAuthorized } from '@/utils/helper'
import { provinces } from '@/data/province'

export default {
  components: {
    SelectWithSearchTable,
    CellRenderTextInput,
    CellRenderDeleteIcon,
    CellHeaderAddIcon,
    MultiGridsTransfer,
    CalendarSelect,
    VxCurrencyInput
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    profileId: {
      type: Number,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      agentItem: {
        name: null,
        email: null,
        note: null,
        profile_code: null,
        invoice_agent_name: null,
        profile_type: null,
        phone_1: '+84',
        phone_2: null,
        address_1: null,
        address_2: null,
        business_code: null,
        tax_code: null,
        bank_number: null,
        bank_name: null,
        nation_id: null,
        state_name: null,
        city_name: null,
        zip_code: null,
        representative_name: null,
        representative_email: null,
        representative_number_phone_1: '+84',
        representative_number_phone_2: null,
        representative_birthday: null,
        representative_id_card: null,
        representative_card_date: null,
        representative_card_place: null,
        market_seg_id: null,
        business_person_id: null,
        source_id: null,
        business_seg_id: null,
        other_infor: false,
        contact_list: [
          // {
          //   name: null,
          //   position: null,
          //   email: null,
          //   note: null,
          //   phone_number_1: null,
          //   phone_number_2: null
          // }
        ],
        agent_debit_list: [
          // {
          //   agent_id: null,
          //   hotel_id: null,
          //   debit_account_id: null,
          //   debit_account_name: null,
          //   main_account: null
          // }
        ],
        max_debt_amount: 0,
        day_owed_num: 0,
        debit_account_id: null,
        debit_account_active: true,
        signed_date: null,
        expired_date: null
      },
      defaultAgentItem: {
        name: null,
        email: null,
        note: null,
        profile_code: null,
        invoice_agent_name: null,
        profile_type: null,
        phone_1: null,
        phone_2: null,
        address_1: null,
        address_2: null,
        business_code: null,
        tax_code: null,
        bank_number: null,
        bank_name: null,
        nation_id: null,
        state_name: null,
        city_name: null,
        zip_code: null,
        representative_name: null,
        representative_email: null,
        representative_number_phone_1: null,
        representative_number_phone_2: null,
        representative_birthday: null,
        representative_id_card: null,
        representative_card_date: null,
        representative_card_place: null,
        market_seg_id: null,
        business_person_id: null,
        source_id: null,
        business_seg_id: null,
        other_infor: false,
        contact_list: [
          // {
          //   name: null,
          //   position: null,
          //   email: null,
          //   note: null,
          //   phone_number_1: null,
          //   phone_number_2: null
          // }
        ],
        agent_debit_list: [
          // {
          //   agent_id: 0,
          //   hotel_id: 0,
          //   debit_account_id: 0,
          //   debit_account_name: null,
          //   main_account: true
          // }
        ],
        max_debt_amount: 0,
        day_owed_num: 0,
        debit_account_id: null,
        debit_account_active: true,
        signed_date: null,
        expired_date: null
      },

      dialogFormVisible: this.value,
      debitAccountDialogVisible: false,

      context: null,

      unAttachedDebtAccountRows: [],
      attachedDebtAccountRows: [],

      // select-with-table-search
      // row for data
      profileTpRows: [
        { code: 1, name: 'Công ty', desc: 'Khách Corporate, Khách Gov' },
        { code: 2, name: 'Đại lý du lịch', desc: 'Các đại lý bán lẻ' },
        { code: 3, name: 'Lữ hành (TA)', desc: 'Doanh nghiệp kinh doanh lữ hành, bán tour' },
        { code: 4, name: 'Cộng tác viên', desc: 'Nhóm các cộng tác viên cá nhân đang đồng hành với MCI' }
      ],
      nationRows: [
        /* { id, code, desc } */
      ],
      businessManRows: [],
      marketSegRows: [],
      sourceRows: [],

      vueTelOptions: {
        autoFormat: true,
        showDialCode: true,
        placeholder: 'Số điện thoại'
      },
      vueTelDialCode: {
        phone_1: null,
        phone_2: null,
        representative_number_phone_1: null,
        representative_number_phone_2: null
      },
      vueTelIso2: {
        phone_1: null,
        phone_2: null,
        representative_number_phone_1: null,
        representative_number_phone_2: null
      },

      // authorize
      checkAuthorAddDebtAccount: false,

      // custom city_name input
      cityInputType: 'select', // 'input'
      provinces: provinces
    }
  },

  computed: {
    // agentItem.contact_list
    contactCols() {
      return [
        {
          headerName: this.$t('config.profile.field.nameMini'),
          field: 'name',
          // cellClass: 'grid-cell-centered',
          minWidth: 100,
          cellRenderer: 'CellRenderTextInput',
          cellRendererParams: () => {
            return {
              type: 'text',
              colName: 'name'
            }
          }
        },
        {
          headerName: this.$t('config.profile.field.position'),
          field: 'position',
          // cellClass: 'grid-cell-centered',
          minWidth: 100,
          cellRenderer: 'CellRenderTextInput',
          cellRendererParams: () => {
            return {
              type: 'text',
              colName: 'position'
            }
          }
        },
        {
          headerName: this.$t('config.profile.field.email'),
          field: 'email',
          // cellClass: 'grid-cell-centered',
          minWidth: 100,
          cellRenderer: 'CellRenderTextInput',
          cellRendererParams: () => {
            return {
              type: 'text',
              colName: 'email'
            }
          }
        },
        {
          headerName: this.$t('config.profile.field.phone1'),
          field: 'phone_number_1',
          // cellClass: 'grid-cell-centered',
          minWidth: 100,
          cellRenderer: 'CellRenderTextInput',
          cellRendererParams: () => {
            return {
              type: 'text',
              colName: 'phone_number_1'
            }
          }
        },
        {
          headerName: this.$t('config.profile.field.phone2'),
          field: 'phone_number_2',
          // cellClass: 'grid-cell-centered',
          minWidth: 100,
          cellRenderer: 'CellRenderTextInput',
          cellRendererParams: () => {
            return {
              type: 'text',
              colName: 'phone_number_2'
            }
          }
        },
        {
          headerName: this.$t('config.profile.field.note'),
          field: 'note',
          // cellClass: 'grid-cell-centered',
          minWidth: 100,
          cellRenderer: 'CellRenderTextInput',
          cellRendererParams: () => {
            return {
              type: 'text',
              colName: 'note'
            }
          }
        },
        {
          headerName: '',
          width: 50,
          cellRenderer: 'CellRenderDeleteIcon',
          headerComponent: 'CellHeaderAddIcon',
          cellStyle: () => {
            return {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }
          }
        }
      ]
    },

    // agentItem.agent_debit_list
    accountReceivableCols() {
      return [
        {
          headerName: this.$t('config.profile.field.hotelId'),
          field: 'hotel_id'
        },
        {
          headerName: this.$t('config.profile.field.debitAccountName'),
          field: 'debit_account_name'
        },
        {
          headerName: this.$t('config.profile.field.mainAccount'),
          field: 'main_account'
        }
      ]
    },
    attachedDebtAccountCols() {
      return [
        {
          headerdesc: '',
          // field: "index",
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: this.$t('config.profile.field.bankName'),
          field: 'account_num',
          // cellClass: "grid-cell-centered",
          width: 80
        },
        {
          headerName: this.$t('config.profile.field.debitAccountName'),
          field: 'name',
          // cellClass: "grid-cell-centered",
          width: 80
        }
      ]
    },

    // select-with-table-search
    // col for display
    sourceCols() {
      return [
        {
          headerName: this.$t('config.profile.select.sourceCode'),
          field: 'code',
          tooltipField: 'code'
        },
        {
          headerName: this.$t('config.profile.select.description'),
          field: 'desc',
          tooltipField: 'desc'
        }
      ]
    },
    marketSegCols() {
      return [
        {
          headerName: this.$t('config.profile.select.marketSegCode'),
          field: 'code',
          tooltipField: 'code'
        },
        {
          headerName: this.$t('config.profile.select.description'),
          field: 'desc',
          tooltipField: 'desc'
        }
      ]
    },
    businessManCols() {
      return [
        {
          headerName: this.$t('config.profile.select.businessManCode'),
          field: 'id',
          tooltipField: 'id'
        },
        {
          headerName: this.$t('config.profile.select.businessManName'),
          field: 'full_name',
          tooltipField: 'full_name'
        }
      ]
    },
    nationCols() {
      return [
        {
          headerName: this.$t('config.profile.select.nationCode'),
          field: 'code',
          tooltipField: 'code'
        },
        {
          headerName: this.$t('config.profile.select.nationName'),
          field: 'desc',
          tooltipField: 'desc'
        }
      ]
    },
    profileTpCols() {
      return [
        {
          headerName: this.$t('config.profile.select.profileType'),
          field: 'name',
          tooltipField: 'name'
        },
        {
          headerName: this.$t('config.profile.select.description'),
          field: 'desc',
          tooltipField: 'desc'
        }
      ]
    }
  },

  methods: {
    onCancel() {
      this.agentItem = { ...this.defaultAgentItem }
      this.dialogFormVisible = false
      this.vueTelDialCode = {
        phone_1: null,
        phone_2: null,
        representative_number_phone_1: null,
        representative_number_phone_2: null
      }
      this.vueTelIso2 = {
        phone_1: null,
        phone_2: null,
        representative_number_phone_1: null,
        representative_number_phone_2: null
      }
    },
    // handle event
    // contact grid
    onDeleteIconClicked(data) {
      const idx = data.rowIndex
      this.agentItem.contact_list.splice(idx, 1)
    },
    onAddRowInGrid() {
      this.agentItem.contact_list.unshift({
        name: null,
        position: null,
        email: null,
        note: null,
        phone_number_1: null,
        phone_number_2: null
      })
    },
    textInputChange(params, data, colName) {
      this.agentItem.contact_list[params.node.rowIndex][colName] = data
    },

    async updateAttachedDebtAccount(rows1, rows2) {
      this.unAttachedDebtAccountRows = rows1
      this.attachedDebtAccountRows = rows2

      this.agentItem.agent_debit_list = []
      this.attachedDebtAccountRows.forEach(row => {
        this.agentItem.agent_debit_list.push({
          agent_id: 0,
          hotel_id: 0,
          debit_account_id: row.id,
          debit_account_name: row.name,
          main_account: false
        })
      })
      if (this.agentItem.agent_debit_list.length > 0) {
        this.agentItem.agent_debit_list[0].main_account = true
      }
      // this.form.package_id_list = this.attachedPackRow?.map((item) => item.id);
    },

    // select with table search
    onSelectProfileTp(data) {
      if (data?.code) {
        if (this.agentItem.profile_type !== data.code) {
          this.agentItem.profile_type = data.code
        }
      } else {
        this.agentItem.profile_type = data
      }
    },
    onSelectNation(data) {
      this.agentItem.nation_id = data?.id || null
      if (data?.code !== 'VNM') {
        this.cityInputType = 'input'
      }
      if (!this.agentItem.nation_id || data?.code === 'VNM') {
        this.cityInputType = 'select'
      }
      this.agentItem.city_name = null
    },
    onSelectCity() {
      this.agentItem.nation_id = this.nationRows?.find(
        item => item.code === 'VNM'
      )?.id
    },
    onSelectBusinessMan(data) {
      this.agentItem.business_person_id = data?.id || null
    },
    onSelectMarketSeg(data) {
      this.agentItem.market_seg_id = data?.id || null
    },
    onSelectSource(data) {
      if (data?.id) {
        if (this.agentItem.source_id !== data.id) {
          this.agentItem.source_id = data.id
        }
      } else {
        this.agentItem.source_id = data
      }
      // this.agentItem.source_id = data?.id || null
    },

    // vue telepone
    onInputTelNum(param) {},
    countryChange1(param) {
      this.vueTelDialCode.representative_number_phone_1 = `+${param.dialCode}`
      this.vueTelIso2.representative_number_phone_1 = param.iso2
    },
    countryChange2(param) {
      this.vueTelDialCode.representative_number_phone_2 = `+${param.dialCode}`
      this.vueTelIso2.representative_number_phone_2 = param.iso2
    },
    countryChangeP1(param) {
      // this.agentItem.phone_1 = `+${param.dialCode}`
      this.vueTelIso2.phone_1 = param.iso2
      this.vueTelDialCode.phone_1 = `+${param.dialCode}`
    },
    countryChangeP2(param) {
      this.vueTelDialCode.phone_2 = `+${param.dialCode}`
      this.vueTelIso2.phone_2 = param.iso2
    },

    // validate form
    async onFormValidate() {
      // // validate phone number 1 required
      // let phone = this.agentItem.phone_1
      //   .replace(`${this.vueTelDialCode.phone_1}`, '')
      //   .trim()

      if (this.agentItem.phone_1 === this.vueTelDialCode.phone_1) {
        this.$message({
          type: 'error',
          message: this.$t(`errorMsg.phone1MustNotNull`)
        })
        return false
      }
      if (this.agentItem.source_id === null) {
        this.$message({
          type: 'error',
          message: this.$t(`errorMsg.sourceMustNotNull`)
        })
        return false
      }

      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return false
      }
      return true
    },

    // btn event
    async addAgent() {
      if ((await this.onFormValidate()) === false) {
        return
      }
      // check contact list: name is required
      for (let contact of this.agentItem.contact_list) {
        if (!contact?.name) {
          this.$message({
            type: 'error',
            message: 'Cột tên trong phần Liên hệ bắt buộc nhập!'
          })
          return
        }
      }
      // data
      let data = {
        ...this.agentItem,
        // phone_2:
        //   this.agentItem.phone_2 === this.vueTelDialCode.phone_2
        //     ? null
        //     : this.agentItem.phone_2,
        representative_number_phone_1:
          this.agentItem.representative_number_phone_1 ===
          this.vueTelDialCode.representative_number_phone_1
            ? null
            : this.agentItem.representative_number_phone_1
        // representative_number_phone_2:
        //   this.agentItem.representative_number_phone_2 ===
        //   this.vueTelDialCode.representative_number_phone_2
        //     ? null
        //     : this.agentItem.representative_number_phone_2
      }

      this.fnAddAgent(data)
    },
    async updateAgent() {
      if ((await this.onFormValidate()) === false) {
        return
      }
      // check contact list: name is required
      for (let contact of this.agentItem.contact_list) {
        if (!contact?.name) {
          this.$message({
            type: 'error',
            message: 'Cột tên trong phần Liên hệ bắt buộc nhập!'
          })
          return
        }
      }
      // data
      if (!this.checkAuthorAddDebtAccount && this.isEdit) {
        this.agentItem.debit_account_active = null
      }
      let data = {
        ...this.agentItem,
        // phone_2:
        //   this.agentItem.phone_2 === this.vueTelDialCode.phone_2
        //     ? this.agentItem.phone_2
        //         .replace(`${this.vueTelDialCode.phone_2}`, '')
        //         .trim()
        //     : this.agentItem.phone_2,
        representative_number_phone_1:
          this.agentItem.representative_number_phone_1 ===
          this.vueTelDialCode.representative_number_phone_1
            ? this.agentItem.representative_number_phone_1
                .replace(
                  `${this.vueTelDialCode.representative_number_phone_1}`,
                  ''
                )
                .trim()
            : this.agentItem.representative_number_phone_1
        // representative_number_phone_2:
        //   this.agentItem.representative_number_phone_2 ===
        //   this.vueTelDialCode.representative_number_phone_2
        //     ? this.agentItem.representative_number_phone_2
        //         .replace(
        //           `${this.vueTelDialCode.representative_number_phone_2}`,
        //           ''
        //         )
        //         .trim()
        //     : this.agentItem.representative_number_phone_2
      }

      this.fnUpdateAgent(data)
    },

    // handle api call
    async fnGetListDebitAccount() {
      try {
        let dataContent = await getListDebitAccount()
        if (!dataContent.is_error) {
          this.unAttachedDebtAccountRows = dataContent.data
        } else {
          throw new Error(dataContent)
        }
      } catch (error) {
        const message = error.response?.data?.message || 'default'
        this.$message({
          type: 'error',
          message: this.$t(`errorMsg.${message}`)
        })
      }
    },
    async fnAddAgent(data) {
      try {
        let res = await addAgentApi(data)
        if (!res.is_error) {
          //
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${res.message}`)
          })
          // close the dialog and reset search
          this.agentItem = { ...this.defaultAgentItem }
          this.dialogFormVisible = false
          this.$emit('resetSearch')
        } else {
          throw new Error(res)
        }
      } catch (error) {
        const message = error.response?.data?.message || 'default'
        this.$message({
          type: 'error',
          message: this.$t(`errorMsg.${message}`)
        })
      } finally {
      }
    },

    // for update
    async fnGetAgentById() {
      if (!this.profileId || !this.isEdit) {
        this.$message({
          type: 'error',
          message: this.$t('config.profile.message.idNotFound')
        })
        this.agentItem = { ...this.defaultAgentItem }
        this.dialogFormVisible = false
        return
      }
      try {
        let res = await getAgentByIdApi({ id: this.profileId })
        if (!res.is_error) {
          this.agentItem = { ...res.data }
          if (!this.agentItem.phone_1)
            this.agentItem.phone_1 = this.vueTelDialCode.phone_1
          if (!this.agentItem.phone_2)
            this.agentItem.phone_2 = this.vueTelDialCode.phone_2
          if (!this.agentItem.representative_number_phone_1)
            this.agentItem.representative_number_phone_1 =
              this.vueTelDialCode.representative_number_phone_1
          if (!this.agentItem.representative_number_phone_2)
            this.agentItem.representative_number_phone_2 =
              this.vueTelDialCode.representative_number_phone_2
        } else {
          throw new Error(res)
        }
      } catch (error) {
        const message = error.response?.data?.message || 'default'
        this.$message({
          type: 'error',
          message: this.$t(`errorMsg.${message}`)
        })
      } finally {
      }
    },
    async fnUpdateAgent(data) {
      try {
        let res = await updateAgentApi(data)
        if (!res.is_error) {
          //
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${res.message}`)
          })
          // close the dialog and reset search
          this.agentItem = { ...this.defaultAgentItem }
          this.dialogFormVisible = false
          this.$emit('resetSearch')
        } else {
          throw new Error(res)
        }
      } catch (error) {
        const message = error.response?.data?.message || 'default'
        this.$message({
          type: 'error',
          message: this.$t(`errorMsg.${message}`)
        })
      } finally {
      }
    }
  },

  watch: {
    value(nv, ov) {
      this.dialogFormVisible = nv
      this.checkAuthorAddDebtAccount = checkAuthorized('ADD_DEBT_ACCOUNT')
      if (!this.checkAuthorAddDebtAccount) {
        this.agentItem.debit_account_active = false
      }
    },
    dialogFormVisible(nv, ov) {
      if (!nv) {
        this.$emit('input', nv)
      }
    },
    isEdit(nv, ov) {
      if (nv) {
        this.fnGetAgentById()
      }
    }
  },

  beforeMount() {
    this.context = { componentParent: this }
  },

  async mounted() {
    this.nationRows = await getAllNation()
    this.businessManRows = await getAllBusinessMan()
    this.marketSegRows = await getAllMarketSeg()
    this.sourceRows = await getAllSource()
    await this.fnGetListDebitAccount()
  }
}
</script>

<style lang="scss">
.das-form-container.datnt > * + * {
  margin: 2rem 0;
}
</style>
